/**
 * Format OTel span context into W3C traceparent header string.
 *
 * @param traceId - The trace ID from span.spanContext().traceId
 * @param spanId - The span ID from span.spanContext().spanId
 * @param sampled - Whether the trace is sampled (default: true)
 * @returns W3C traceparent header value
 *
 * @example
 * const span = tracer.startSpan('operation');
 * const traceparent = formatTraceparent(
 *   span.spanContext().traceId,
 *   span.spanContext().spanId,
 *   true
 * );
 */
export const formatTraceparent = (
  traceId: string,
  spanId: string,
  sampled: boolean = true
): string => {
  const version = '00';
  const flags = sampled ? '01' : '00';
  return `${version}-${traceId}-${spanId}-${flags}`;
};
